import 'react-tooltip/dist/react-tooltip.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/sv';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { isEmpty } from 'lodash';
import IfComponent from '../IfComponent';
import Translate from '../Translate';
import Header from './Header';
import SingleEvent from './SingleEvent';
import {
  get24HoursInday,
  generateUniqueId,
  getDateRangeFromWeek,
  getRangeOfDates,
  filterEventInDay,
  filterEventInWeek,
  filterAvailabilityInDay,
} from '../../utils';
import './style.scss';
import './responsive.scss';
import { checkIfWeekend } from '../../utils/dateUtil';
import { truncateTextName } from '../../utils/fileUtil';

const propTypes = {
  className: PropTypes.string,
  date: PropTypes.shape({}),
  selectedEvent: PropTypes.shape({}),
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  onEventClick: PropTypes.func,
  onDayClick: PropTypes.func,
  onCreateOrder: PropTypes.func,
  children: PropTypes.node,
  events: PropTypes.arrayOf(PropTypes.shape({})),
  availability: PropTypes.arrayOf(PropTypes.shape({})),
};

const defaultProps = {
  className: '',
  selectedEvent: {},
  date: moment(),
  onPrevious: () => {},
  onNext: () => {},
  onEventClick: () => {},
  onDayClick: () => {},
  onCreateOrder: () => {},
  children: null,
  events: [],
  availability: [],
};

const calculateEventAttributes = (event, heightBase = 50) => {
  let top = 0;
  let height = 0;
  if (event) {
    const { from, to } = event;
    const startDay = from.clone().startOf('day');

    if (from.isSame(to, 'day')) {
      height = moment.duration(to.diff(from)).asHours() * heightBase;
      top = moment.duration(from.diff(startDay)).asHours() * heightBase + 50; // add a row in top calendar for > 1 day
    } else {
      // const newToData = from.clone();
      height = 25;
      top = 0;
    }
    return {
      top,
      height,
    };
  }
};
const calculateAvailabilityAttributes = (
  availability,
  selectedCalendarDay,
  heightBase = 50,
) => {
  let top = 0;
  let height = 0;
  if (availability) {
    const { DatetimeFrom, DatetimeTo } = availability;
    const { from, to } = {
      from: moment(DatetimeFrom),
      to: moment(DatetimeTo),
    };
    let [timeFrom, timeTo] = [from.format('HH:mm'), to.format('HH:mm')];
    const startDay = from.clone().startOf('day');
    // add a row in top calendar for > 1 day
    const startSameDay = from
      .clone()
      .startOf('day')
      .isSame(selectedCalendarDay.clone().startOf('day'));
    const endSameDay = to
      .clone()
      .startOf('day')
      .isSame(selectedCalendarDay.clone().startOf('day'));
    if (startSameDay && endSameDay) {
      top = moment.duration(from.diff(startDay)).asHours() * heightBase;
      height = moment.duration(to.diff(from)).asHours() * heightBase;
    } else if (!startSameDay && endSameDay) {
      top = 0;
      height = moment
          .duration(to.diff(selectedCalendarDay.clone().startOf('day')))
          .asHours() * heightBase;
      timeFrom = '00:00';
    } else if (startSameDay && !endSameDay) {
      top = moment.duration(from.diff(startDay)).asHours() * heightBase;
      height = moment
          .duration(selectedCalendarDay.clone().endOf('day').diff(from))
          .asHours() * heightBase;
      timeTo = '23:59';
    } else if (!startSameDay && !endSameDay) {
      top = 0;
      height = 24 * heightBase;
      timeFrom = '00:00';
      timeTo = '23:59';
    }
    return {
      timeFrom,
      timeTo,
      top,
      height,
    };
  }
};
class WeeklyCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
    this.scrollContainer = React.createRef();
    this.hours = get24HoursInday();
  }

  componentDidMount() {
    window.addEventListener('resize', () => this.setState({
        windowWidth: window.innerWidth,
      }),
    );
  }

  handleavailabilityBarClick = (event, articleType) => {
    const availabilityDay = event.target.getAttribute('data-date') || '';
    if (availabilityDay !== '') {
      this.props.onAvailabilityClick(
        event,
        moment(availabilityDay),
        articleType,
      );
    }
  };

  shorterFileName = (fname, sname) => {
    const EXPECT_LENGTH = 13;
    return truncateTextName(fname, sname, EXPECT_LENGTH);
  };

  checkCurrentlySelectedEvent = event => {
    const { selectedEvent } = this.props;
    const currentlySelectedEvent = !isEmpty(selectedEvent)
      && selectedEvent.OrderIdentifier === event.assignment.OrderIdentifier;

    return currentlySelectedEvent;
  };

  render() {
    const {
      className,
      date,
      onPrevious,
      onNext,
      children,
      events,
      selectedEvent,
      onEventClick,
      availability,
      onDayClick,
      onCreateOrder,
    } = this.props;
    const normalEvents = events.filter(
      event => event.isMessageService != true && event.isTranslation != true,
    );
    const messageAndTranslationEvents = events.filter(
      event => (event.isMessageService === true && event.isTranslation === false)
        || (event.isMessageService === false && event.isTranslation === true),
    );
    const { week, year } = date;
    const dateRangeFromWeek = getDateRangeFromWeek(week, year);
    const dates = getRangeOfDates(
      dateRangeFromWeek.start,
      dateRangeFromWeek.end,
      'day',
    );
    const eventsAllDays = filterEventInWeek(normalEvents, dates).filter(
      x => !x.from.isSame(x.to, 'day'),
    );
    const messageEventsInWeek = filterEventInWeek(
      messageAndTranslationEvents,
      dates,
    );
    eventsAllDays.map(x => {
      x.isCheck = false;
      return x;
    });
    const eventDataAllDay = [];
    const { windowWidth } = this.state;
    [...eventsAllDays].forEach((x, index) => {
      const groupsAllDays = [];
      [...eventsAllDays].forEach(v => {
        if (
          x.from.isBetween(v.from, v.to, 'day', '[]')
          || x.to.isBetween(v.from, v.to, 'day', '[]')
        ) {
          if (!v.isCheck) {
            v.isCheck = true;
            v.number = index;
            groupsAllDays.push(v);
          }
        }
      });
      if (groupsAllDays.length > 0) {
        eventDataAllDay.push(groupsAllDays);
      }
    });

    let initialHeight = 0;
    const defaultHeight = 33;
    {
      dates.map(dateItem => {
        const dayCount = filterEventInDay(
          messageAndTranslationEvents,
          dateItem,
          false,
        );
        if (dayCount.length >= initialHeight) {
          initialHeight = dayCount.length;
        }
      });
    }
    const height = `${(initialHeight * defaultHeight).toString()}px`;

    return (
      <div
        style={{ position: 'relative' }}
        className={`tk-calendar__wrapper tk-weekly-calendar__wrapper ${className}`}
      >
        {/* <div className="message-icon">
          {' '}
          <li className="mr-2 fa fa-comment" role='list'></li>
        </div> */}
        <Header date={date} onPrevious={onPrevious} onNext={onNext}>
          {children}
        </Header>
        <div className="tk-weekly-calendar__day-header tv-display-flex tv-display-mobile-hide">
          {dates.map((dateItem, i) => {
            const toDayClass = moment(dateItem).isSame(moment(), 'day')
              ? 'today'
              : '';
            return (
              <div
                className={`tk-weekly-calendar__day-row week-header ${toDayClass}`}
                key={i.toString()}
              >
                <div className="round-dot" />
                {dateItem.locale('sv').format('dddd D')}
              </div>
            );
          })}
        </div>

        <div className="tk-weekly-calendar-events tv-display-flex flex-column flex-md-row">
          {dates.map((dateItem, i) => {
            const eventInDay = filterEventInDay(normalEvents, dateItem, false) || [];
            const messageServiceEvents = messageAndTranslationEvents.filter(
              event => event.isMessageService === true
                && event.isTranslation === false,
            );
            const translationEvents = messageAndTranslationEvents.filter(
              event => event.isMessageService === false
                && event.isTranslation === true,
            );
            const messageEventInDay = filterEventInDay(messageServiceEvents, dateItem, false) || [];
            const translationEventInDay = filterEventInDay(translationEvents, dateItem, false) || [];
            //  eventInDay = eventInDay.sort((a, b) => a.from - b.from);

            const toDayClass = moment(dateItem).isSame(moment(), 'day')
              ? 'today'
              : '';
            return (
              <div
                className={`tk-weekly-calendar__day-row ${
                  checkIfWeekend(dateItem) ? 'weekend-background' : ''
                }`}
                key={i.toString()}
              >
                <div className="tk-weekly-calendar__item-number tv-display-mobile-show">
                  <span className="tk-weekly-calendar__item-text">
                    {dateItem.locale('sv').format('dddd, DD MMMM')}
                  </span>
                </div>
                <div className="message-event" style={{ height }}>
                  {messageEventInDay.map(event => (
                    <div
                      onClick={() => onEventClick(null, event.assignment.OrderIdentifier)}
                      className={`event event-${event.orderStatus} ${
                        this.checkCurrentlySelectedEvent(event)
                          ? 'event-selected'
                          : ''
                      }`}
                      id={event.assignment.OrderIdentifier}
                      name="messageService"
                      tabIndex={0}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          onEventClick(null, event.assignment.OrderIdentifier);
                        }
                      }}
                    >
                      <div className="mr-2 fa fa-comment" role="list" />
                      {this.shorterFileName(
                        event.assignment.OrderNumber,
                        event.assignment.ContactPersonOrderer
                          .ContactPersonOrdererName,
                      )}
                    </div>
                  ))}
                  {translationEventInDay.map(event => (
                    <div
                      onClick={() => onEventClick(null, event.assignment.OrderIdentifier)}
                      className={`event event-${event.orderStatus}`}
                      id={event.assignment.OrderIdentifier}
                      name="messageService"
                      tabIndex={0}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          onEventClick(null, event.assignment.OrderIdentifier);
                        }
                      }}
                    >
                      <li className="mr-2 fa fa-language" role="list" />
                      {this.shorterFileName(
                        event.assignment.OrderNumber,
                        event.assignment.ContactPersonOrderer
                          .ContactPersonOrdererName,
                      )}
                    </div>
                  ))}
                </div>
                <IfComponent
                  condition={!!eventInDay.length}
                  whenTrue={(
                    <>
                      {eventInDay.map(item => (
                        <SingleEvent
                          key={item.assignment.OrderIdentifier}
                          selectedEvent={selectedEvent}
                          onClick={onEventClick}
                          date={dateItem}
                          event={item}
                        />
                      ))}
                    </>
                  )}
                  whenFalse={(
                    <div className="tk-weekly-calendar__item-empty tv-display-mobile-show">
                      {Translate({
                        content: 'calendar.no_assignments',
                      })}
                    </div>
                  )}
                />
                <IfComponent
                  condition={dateItem.diff(moment().startOf('day'), 'day') > 0}
                  whenTrue={(
                    <div
                      className="tk-weekly-calendar__item-add tv-display-mobile-hide"
                      onClick={e => {
                        e.stopPropagation();
                        onCreateOrder(dateItem);
                      }}
                    >
                      +
                      {' '}
                      {Translate({
                        content: 'calendar.addNew',
                      })}
                    </div>
                  )}
                />
              </div>
            );
          })}
        </div>
        <ReactTooltip
          anchorId="messageService"
          place="bottom"
          variant="info"
          style={{ backgroundColor: '#c25706' }}
          content="Open"
        />
      </div>
    );
  }
}

WeeklyCalendar.propTypes = propTypes;
WeeklyCalendar.defaultProps = defaultProps;

export default WeeklyCalendar;
